import { QueryHookOptions, useQuery } from '@apollo/client';

import query from './userAppsLinks.graphql';

export default function useUserAppsLinksQuery(
  opts?: QueryHookOptions<UserAppsLinksQuery, UserAppsLinksQueryVariables>,
) {
  return useQuery<UserAppsLinksQuery, UserAppsLinksQueryVariables>(query, opts);
}
